// extracted by mini-css-extract-plugin
export default {"draft-select":"index-module__draft-select--Xfq_x"};